<template>
    <div class="content">
        <div>
            <el-card class="box-card">
                <div slot="header" class="clearfix">
                    <span class="text">查询条件</span>
                </div>
                <div class="box-cont">
                    <el-form :model="queryParams" ref="queryForm" :inline="true">
                        <el-form-item label="单位名称:" prop="dwmc">
                            <el-input style="width:65%;"
                            v-model="queryParams.dwmc"
                            placeholder="请输入单位名称"
                            clearable
                            size="small"
                            @keyup.enter.native="handleQuery"
                            />
                        </el-form-item>
                        <el-form-item label="专业类别:" prop="zylb">
                            <el-select v-model="queryParams.zylb" clearable placeholder="请选择专业类别" size="small">
                                <el-option
                                    v-for="dict in zylbOptions"
                                    :key="dict.ID"
                                    :label="dict.mc"
                                    :value="dict.ID"
                                    ></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="法定代表人:" prop="fr">
                            <el-input style="width:65%;"
                            v-model="queryParams.fr"
                            placeholder="请输入单位名称"
                            clearable
                            size="small"
                            @keyup.enter.native="handleQuery"
                            />
                        </el-form-item>
                        <el-form-item style="text-align:right;">
                            <el-button type="primary" icon="el-icon-search" size="small" @click="handleQuery">查询</el-button>
                            <el-button icon="el-icon-refresh" size="small" @click="resetQuery">重置</el-button>
                        </el-form-item>
                    </el-form>
                </div>
            </el-card>
            <el-card class="box-card">
                <div slot="header" class="clearfix">
                    <span class="text">查询结果</span>
                </div>
                <div class="box-cont">
                    <el-table v-loading="loading" :data="ajslList">
                        <el-table-column  align="center" :show-overflow-tooltip="true"  label="序号" width="60">
                            <template slot-scope="scope">
                                <span>{{(scope.$index+1) + ( queryParams.limit * (queryParams.page-1))}}</span>
                            </template>
                        </el-table-column>
                        <el-table-column label="专业类别" align="center" prop="zylb" width="120"  />
                        <el-table-column label="监督对象名称" prop="dwmc" width="200" />
                        <el-table-column label="单位地址" prop="dwdz" />
                        <el-table-column label="状态" prop="status" width="80" >
                            <template slot-scope="scope">
                                <el-tag size="small" v-if="scope.row.status==1" type="success">保存</el-tag>
                                <el-tag size="small" v-else-if="scope.row.status==0" type="warning">暂存</el-tag>
                            </template>
                        </el-table-column>
                        <el-table-column label="法人" align="center" prop="fr" width="90"  />
                        <el-table-column label="手机号" align="center" prop="sj1" width="120" />
                        <el-table-column label="操作" align="center" class-name="small-padding fixed-width" width="80" >
                            <template slot-scope="scope">
                                <el-button
                                size="small"
                                type="text"
                                @click="handleXq(scope.row)"
                            >详情</el-button>
                            <!--<el-button
                                size="small"
                                type="text"
                                @click="handleDelete(scope.row)"
                            >删除</el-button>-->
                            </template>
                        </el-table-column>
                    </el-table>
                    <div class="page-part" style="padding:20px 20px 50px;">
                        <el-pagination  v-if="pageshow"
                            background
                            @size-change='handleSizeChange'
                            @current-change='handleCurrentChange'
                            :current-page="queryParams.page"
                            :page-sizes="[10,20,30,40]"
                            :page-size="queryParams.limit"
                            layout="total, prev, pager, next, jumper"
                            :total="total" style=" float:right;">
                        </el-pagination>
                    </div>
                </div>
            </el-card>
        </div>
        <el-dialog  :visible="open" width="800px" height="500px" > 
            <Znxq :dwInfo="dwInfo" @close="getBack"></Znxq>
        </el-dialog>
    </div>
</template>

<script>
import axios from 'axios'
import qs from 'qs'
import Znxq from './znxq.vue'
export default {
    name: "Layout",
    data() {
        return {
            loading:false,
            dm:'',
            cmid:'',
            queryParams:{
                dwmc:'',
                zylb:'',
                fr:'',
                page:1,
                limit:10,
            },
            total:0,
            ajslList:[],
            zylbOptions:[],
            pageshow:true,
            ajId:'',
            dwId:'',
            open:false,
            sc: "",
            xg: "",
            xz: "",
            dwInfo:{},
            baseUrl:''
        }
    },
    components: {
        Znxq
    },
    computed: {
    },
    created() {
    },
    async mounted() {
        let quxian = JSON.parse(sessionStorage.getItem("quxiandata"));
        console.log(quxian)
        if(quxian && quxian.length > 0){
            quxian.forEach(ele=> {
                if(ele.item == '一般程序辅助办案列表'){
                    this.sc = ele.sc
                    this.xg = ele.xg
                    this.xz = ele.xz
                }
            })
        }
        let user = JSON.parse(sessionStorage.getItem("userdata"));
        this.cmid = user.c_mid
        this.dm = user.dm
        this.baseUrl = user.baseUrl
        axios({
            method: 'post',
            url: this.baseUrl+`/login/getZylb`,
            data:{
                 "cfxt":""
            },
            headers: { 
                "Content-Type": "application/json"
            },
        }).then(res => {
            if(res.data.code == 0 && res.data.data){
                this.zylbOptions = res.data.data
            }else{
                if(res.data.msg){
                    this.$message.error(res.data.msg)
                }
            }
        }).catch(error => {
            this.$message.error(error);
        })
        
        this.getList()
    },
    methods: {
        async getList(){
            this.loading = true
            this.ajslList = []
            this.total = 0
            axios({
                method: 'post',
                url: this.baseUrl+`/system/power/reasoningData`,
                headers: { // 添加请求头
                    "Content-Type": "application/json" // 明确声明为 JSON 格式
                },
                data: {
                    dwmc:this.queryParams.dwmc,
                    zylb:this.queryParams.zylb,
                    fr:this.queryParams.fr,
                    cmid:this.cmid,
                    pageSize:this.queryParams.limit,
                    pageNum:this.queryParams.page
                }
            })
            .then(response => {
                console.log(response.data);
                this.ajslList = response.data.data.list
                this.total = response.data.data.total || 0
                this.loading = false
            })
            .catch(error => {
                this.loading = false
                this.$message.error('获取数据失败！');
                console.error('There was an error!', error);
            });
        },
        handleQuery(){
            this.pageshow = false;
            this.queryParams.page = 1
            this.getList()
            this.$nextTick(() => {
                this.pageshow = true;
            });
        },
        resetQuery(){
            this.queryParams.page = 1
            this.queryParams = {
                dwmc:'',
                zylb:'',
                fr:'',
                page:1,
                limit:10,
            }
            this.getList()
        },
        handleSizeChange(val){
            this.pagesize = val
            this.getList()
        },
        handleCurrentChange(val){
            this.pageshow = false;
            this.queryParams.page = val
            this.getList()
            this.$nextTick(() => {
                this.pageshow = true;
            });
        },
        handleXq(row){
            sessionStorage.removeItem('ajxq')
            this.$router.push({name:'/znxq',
                query:{
                    lsh:row.lsh,
                    mid:row.mid,
                    status:row.status,
                }
            })
            sessionStorage.setItem("ajxq", JSON.stringify(row));
        },
        handleDelete(row){
            this.$confirm("您确认要删除这条记录吗?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning"
            })
            .then(async () => {
                
                    
            })
            .catch(() => {
                this.$message({
                    type: "info",
                    message: "已取消删除"
                });
            });			
        },
        getBack(){}
    }
}
</script>


<style scoped>
</style>